module.exports = __webpack_public_path__ + "media/images/icons/form_musician_step_2-d3e1f310905ccecd6c9bb37e7ed5eeba.svg";